const diffDirection = (diff?: [-1 | 0 | 1, string][]) => {
  return Array.isArray(diff) && diff.length > 0
    ? diff.find(item => item[0] !== 0)?.[0]
    : 0;
};

export default diffDirection;
